import {MenuItem} from 'mx-core';

export const MENU_ITEMS: MenuItem[] = [
    {
        label: 'label.menu.dashboard',
        icon: 'dashboard',
        link: '/dashboard'
    },
    {
        label: 'label.menu.stats',
        icon: 'equalizer',
        link: '/statistic'
    },
    {
        label: 'label.menu.marketing.tools',
        icon: 'construction',
        link: '/marketing-tools'
    },
    {
        label: 'label.menu.profiles',
        icon: 'people',
        link: '/profiles'
    },
    {
        label: 'label.menu.account.details',
        icon: 'account_circle',
        link: '/account'
    },
    {
        label: 'label.menu.finance',
        icon: 'payment',
        link: '/finance'
    },
    {
        label: 'label.menu.info',
        icon: 'info',
        link: '/info'
    },
];
